import {
    ActuatorAccessoriesPageAmDocument,
    ActuatorAccessoriesPageAmQuery,
    ActuatorAccessoriesPageAmQueryVariables, ActuatorAccessoriesPageApDocument, ActuatorAccessoriesPageApQuery,
    ActuatorAccessoriesPageApQueryVariables, ActuatorAccessoriesPageEuDocument,
    ActuatorAccessoriesPageEuQuery, ActuatorAccessoriesPageEuQueryVariables,
    RegionsEnum,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { getActuatorsListPageConfig } from 'src/actuators/list/ActuatorsListPageMapping.ts';

export type ActuatorAccessoriesPageData = Omit<
ActuatorAccessoriesPageEuQuery | ActuatorAccessoriesPageApQuery | ActuatorAccessoriesPageAmQuery,
'__typename'
>;
export type ActuatorAccessoriesPageVariables = Omit<
ActuatorAccessoriesPageEuQueryVariables
| ActuatorAccessoriesPageApQueryVariables
| ActuatorAccessoriesPageAmQueryVariables,
'__typename'
>;

export type ActuatorAccessoriesPageConfig = {
    mainFilterConfig: FilterConfig;
    query: DocumentNode;
    additionalFilterConfig: FilterConfig;
}

export const getActuatorAccessoriesPageConfig = (region: RegionsEnum): ActuatorAccessoriesPageConfig | null => {
    const actuatorsPageConfig = getActuatorsListPageConfig(region);
    if (actuatorsPageConfig === null) {
        throw new Error('No Actuators Page Config');
    }
    const {
        mainFilterConfig,
        filterConfig: additionalFilterConfig,
    } = actuatorsPageConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(ActuatorAccessoriesPageEuDocument),
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(ActuatorAccessoriesPageApDocument),
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(ActuatorAccessoriesPageAmDocument),
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    return null;
};
